export type ID = string

export const equalId = (first: ID | undefined, second: ID | undefined): boolean => {
  if (first === second) {
    return true
  }

  if (!first && second) {
    return false
  }

  if (first && !second) {
    return false
  }

  return String(first) === String(second)
}
